<template>
    <div class="profile-page">
        <!-- 头像区域 -->
        <div class="avatar-section">
            <div class="avatar-wrapper">
                <img :src="userInfo.avatar" alt="avatar">
            </div>
        </div>

        <!-- 信息表单 -->
        <van-form class="info-form">
            <!-- 姓名 -->
            <van-field
                v-model="userInfo.name"
                label="姓名"
                :border="false"
                input-align="right"
                readonly
            />

            <!-- 身份证号 -->
            <van-field
                v-model="userInfo.idCard"
                label="身份证号"
                :border="false"
                input-align="right"
                readonly
            />

            <!-- 手机号 -->
            <van-field
                v-model="userInfo.phone"
                label="手机号"
                :border="false"
                input-align="right"
                readonly
            />
        </van-form>

        <!-- 其他信息 -->
        <div class="other-info">
            <!-- 用户类型 -->
            <van-field
                v-model="userInfo.type"
                label="用户类型"
                :border="false"
                input-align="right"
                readonly
            />

            <!-- 所属医院 -->
            <van-field
                v-model="userInfo.hospital"
                label="所属医院"
                :border="false"
                input-align="right"
                readonly
            />
            
            <!-- 账号（只读） -->
            <van-field
                v-model="userInfo.account"
                label="账号"
                :border="false"
                input-align="right"
                readonly
            />
        </div>

    </div>
</template>

<script>
export default {
    name: 'Profile',
    data() {
        return {
            userInfo: {
                id: '',
                name: '',
                account: '',
                avatar: '',
                idCard: '',
                phone: '',
                hospital: '',
                type: ''
            }
        };
    },
    created() {
        // 从 Vuex 获取用户信息
        const storeUserInfo = this.$store.state.userInfo || {};
        if (storeUserInfo.id) {
            this.userInfo = {
                id: storeUserInfo.id || '',
                name: storeUserInfo.name || '',
                account: storeUserInfo.account || '',
                avatar: storeUserInfo.avatar || 'https://img.yzcdn.cn/vant/cat.jpeg',
                idCard: storeUserInfo.idCard || '',
                phone: storeUserInfo.phone || '',
                hospital: storeUserInfo.hospital || '',
                type: storeUserInfo.type || ''
            };
        }
    },
    methods: {}
};
</script>

<style scoped lang='scss'>
.profile-page {
    min-height: 100vh;
    background: #f5f5f5;
}

.avatar-section {
    background: linear-gradient(to bottom, #C2E5EB, #EEF4F5);
    padding: 40px 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.avatar-wrapper {
    position: relative;
    width: 80px;
    height: 80px;
}

.avatar-wrapper img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid rgba(255, 255, 255, 0.8);
}


.info-form {
    background: #fff;
    margin: 15px;
    border-radius: 12px;
    overflow: hidden;
    
    ::v-deep .van-cell {
        padding: 16px 15px;
        
        &::after {
            border-bottom: 1px solid #f5f5f5;
        }
        
        &:last-child::after {
            border-bottom: none;
        }
    }
    
    ::v-deep .van-field__label {
        font-size: 15px;
        color: #333;
        font-weight: 500;
        width: 80px;
    }
    
    ::v-deep .van-field__value {
        font-size: 15px;
    }
    
    ::v-deep .van-field__control {
        color: #333;
        
        &::placeholder {
            color: #c8c9cc;
        }
    }
}

.other-info {
    background: #fff;
    margin: 15px;
    border-radius: 12px;
    overflow: hidden;
    
    ::v-deep .van-cell {
        padding: 16px 15px;
        
        &::after {
            border-bottom: 1px solid #f5f5f5;
        }
        
        &:last-child::after {
            border-bottom: none;
        }
    }
    
    ::v-deep .van-field__label {
        font-size: 15px;
        color: #333;
        font-weight: 500;
        width: 80px;
    }
    
    ::v-deep .van-field__value {
        font-size: 15px;
    }
    
    ::v-deep .van-field__control {
        color: #333;
        
        &::placeholder {
            color: #c8c9cc;
        }
    }
    
}
</style>

